import React from "react"
import PropTypes from "prop-types"
import GoogleMap from "google-map-react"
import { MapMarker } from "components"
import { HAS_TOUCH } from "constants/environment"
import { withRadium } from "higher-order-components"
import { getGoogleMapsApi } from "apis/google-maps"

const defaultOptions = {
  gestureHandling: "auto",
  mapTypeControl: false,
  scrollwheel: false,
  disableDoubleClickZoom: HAS_TOUCH,
  fullscreenControl: false
}

const MapWithMarkers = ({
  defaultCenter,
  defaultZoom,
  map,
  locations,
  activeIndex,
  handleClickOnLocation,
  options,
  ...rest
}) => (
  <div>
    <div style={styles.googleMapContainer}>
      <GoogleMap
        {...rest}
        resetBoundsOnResize
        googleMapLoader={getGoogleMapsApi}
        defaultCenter={defaultCenter}
        defaultZoom={defaultZoom}
        zoom={map.zoom}
        center={map.center}
        options={{ ...defaultOptions, ...options }}
        lockCenter >
        {locations &&
            locations.map((marker, index) => (
              <MapMarker
                key={index}
                lat={marker.lat}
                lng={marker.lng}
                animationDelay={
                  (locations
                    .slice()
                    .sort((a, b) => b.lat - a.lat)
                    .indexOf(marker) +
                    1) *
                  0.25 +
                  0.666
                }
                zIndex={activeIndex === index ? 100000 : index}
                text={marker.name}
                active={activeIndex === index}
                hover={marker.hover}
                onClick={() => {
                  handleClickOnLocation(index)
                }} />
            ))}
      </GoogleMap>
    </div>
  </div>
)

MapWithMarkers.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    lat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    lng: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })),
  activeIndex: PropTypes.number,
  defaultZoom: PropTypes.number,
  defaultCenter: PropTypes.object,
  map: PropTypes.shape({
    zoom: PropTypes.number,
    center: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    })
  }),
  options: PropTypes.object,
  handleClickOnLocation: PropTypes.func
}

MapWithMarkers.defaultProps = {
  map: {
    center: {
      lat: -37.8390361,
      lng: 144.9997397
    },
    zoom: 17
  },
  options: {},
  handleClickOnLocation: () => { }
}

const styles = {
  googleMapContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  }
}

export default withRadium()(MapWithMarkers)



// WEBPACK FOOTER //
// ./src/components/map-with-markers/index.jsx